module.exports = __webpack_public_path__ + "img/sushi-king-menu-07.0c445361.png";